// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <div class="info">
    <div class="info__column">
      <div class="info__field">
        <span class="info__field-label">Description:</span>
        <span class="info__field-value">Device update</span>
      </div>
      <div class="info__field">
        <span class="info__field-label">Branch name:</span>
        <span class="info__field-value">{{\$ctrl.branch.name}}</span>
      </div>
      <div class="info__field">
        <span class="info__field-label">Agent name:</span>
        <span class="info__field-value">{{\$ctrl.agent.effectiveName}}</span>
      </div>
      <div class="info__field">
        <span class="info__field-label">Device code:</span>
        <span class="info__field-value">{{\$ctrl.device.code}}</span>
      </div>
    </div>
  </div>

<ng-form name="\$ctrl.form">

  <device-details device="\$ctrl.device"></device-details>

  <div class="clearfix"></div>

  <div class="buttons">
    <button class="btn btn-warning"
            ng-click="\$ctrl.redirectBack()">
      Cancel
    </button>
    <button type="submit"
            class="btn btn-primary"
            ng-click="\$ctrl.update()"
            command-access="UpdateDevice"
            ng-disabled="\$ctrl.form.\$invalid">
      Save
    </button>
  </div>
</ng-form>
</section>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/agent-banking/details/devices/agent-device-details.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;